import { preview } from '@/components/form/preview'
import { Header } from './components/Header/Header'
import { useBulkViewData } from './hooks/useBulkViewData/useBulkViewData'
import { Company } from './components/fields/Company'
import { Eligibility } from './components/fields/Eligibility'
import { Loads } from './components/fields/Loads'
import { Vehicle } from './components/fields/Vehicle'
import { Priority } from './components/fields/Priority'
import { useTexts } from './hooks/useTexts'
import { Phone } from './components/fields/Phone'
import { Email } from './components/fields/Email'
import { ServiceTime } from './components/fields/ServiceTime'
import { TimeWindows } from './components/fields/TimeWindows'
import { RequiredTags } from './components/fields/RequiredTags'
import { BannedTags } from './components/fields/BannedTags'
import { Notes } from './components/fields/Notes'

type Props = {
  orders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function BulkPreview(props: Props) {
  const { orders } = props
  const texts = useTexts()

  const bulkData = useBulkViewData(orders)

  // Hide loads for services (type 's')
  const showLoads: boolean = orders[0]?.orderStep.type !== 's'

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header orders={orders} />}>
      <Company bulkData={bulkData} />
      <preview.Divider />

      <Eligibility bulkData={bulkData} />
      <preview.Divider />

      {showLoads && (
        <>
          <Loads bulkData={bulkData} />
          <preview.Divider />
        </>
      )}

      <Vehicle bulkData={bulkData} />
      <preview.Divider />

      <Priority bulkData={bulkData} />
      <preview.Divider />

      <preview.Section spacing={1}>
        <preview.SectionTitle>{texts.contactInformation.title}</preview.SectionTitle>
        <Phone bulkData={bulkData} />
        <Email bulkData={bulkData} />
      </preview.Section>
      <preview.Divider />

      <preview.Section spacing={1}>
        <preview.SectionTitle>{texts.serviceTime.title}</preview.SectionTitle>
        <ServiceTime bulkData={bulkData} />
        <TimeWindows bulkData={bulkData} />
      </preview.Section>
      <preview.Divider />

      <preview.Section spacing={1}>
        <preview.SectionTitle>{texts.additionalDetails.title}</preview.SectionTitle>
        <RequiredTags bulkData={bulkData} />
        <BannedTags bulkData={bulkData} />
        <Notes bulkData={bulkData} />
      </preview.Section>
    </preview.Root>
  )
}
